import React from 'react';

/**
 * TemplatesProgressBar Component
 * مسؤول عن عرض شريط التقدم للأقسام (Templates) مع التحكم في التنقل.
 */
const TemplatesProgressBar = ({
    sections,
    activeSectionIndex,
    windowIndex,
    onSectionClick,
    onNext,
    onPrev
}) => {
    // عرض 3 أقسام فقط في المرة الواحدة بناءً على الـ windowIndex
    const visibleSections = sections.slice(windowIndex, windowIndex + 3);

    return (
        <div className='d-flex flex-column align-items-center w-100'>
            <div className='d-flex justify-content-center align-items-center w-100'>
                {sections.length > 1 && (
                    <div
                        className="border-top border-3 position-relative mt-5 mb-4 d-flex justify-content-between"
                        style={{ width: '60%', minWidth: '300px' }} // عرض متوازن للحاوية
                    >
                        {visibleSections.map((section, index) => {
                            const globalIndex = windowIndex + index;
                            const sectionName = section[0]?.pirm_addon__Question__r?.pirm_addon__Template__r?.Name || 'Unnamed';

                            return (
                                <div key={globalIndex} className="position-relative">
                                    {/* اسم القسم فوق الدائرة */}
                                    <div
                                        className="position-absolute bottom-100 start-50 translate-middle-x mb-2"
                                        style={{ width: '120px' }} // تحديد عرض منطقة النص
                                    >
                                        <p
                                            className="fs-6 mb-0 text-center"
                                            title={sectionName} // يظهر الاسم كامل عند الوقوف بالماوس
                                            style={{
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                cursor: 'help'
                                            }}
                                        >
                                            {sectionName}
                                        </p>
                                    </div>

                                    {/* الدائرة القابلة للضغط */}
                                    <div
                                        onClick={() => onSectionClick(globalIndex)}
                                        className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle"
                                        style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            background: 'var(--surface)',
                                            cursor: 'pointer',
                                            zIndex: 2
                                        }}>
                                        {/* الدائرة اللي لونها بيتغير (المتوسطة) */}
                                        <div style={{
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '50%',
                                            transition: 'background 0.3s ease',
                                            background: activeSectionIndex === globalIndex ? 'var(--accent)' : 'var(--surface)',
                                            // --- ضيف الـ 3 سطور دول عشان يسنتروا اللي جواهم ---
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            {/* الدائرة الصغيرة جداً (البيضاء أو الرمادية) */}
                                            <div style={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                // شيل الـ marginTop والـ m-auto خالص لأن الـ Flexbox قايم بالواجب
                                                background: activeSectionIndex === globalIndex ? 'var(--surface)' : 'var(--hairline-strong)'
                                            }} />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* أزرار التنقل (الأسهم) */}
            {sections.length > 3 && (
                <div className="d-flex justify-content-center align-items-center fa-xl mt-3">
                    <i
                        className={`fa-regular fa-circle-left ms-4 ${windowIndex <= 0 ? 'text-muted' : ''}`}
                        onClick={windowIndex > 0 ? onPrev : null}
                        style={{
                            cursor: windowIndex <= 0 ? 'not-allowed' : 'pointer',
                            color: windowIndex <= 0 ? 'var(--hairline-strong)' : "var(--accent)",
                            transition: 'color 0.2s'
                        }}
                    />

                    <i
                        className={`fa-regular fa-circle-right ms-4 ${windowIndex >= sections.length - 3 ? 'text-muted' : ''}`}
                        onClick={windowIndex < sections.length - 3 ? onNext : null}
                        style={{
                            cursor: windowIndex >= sections.length - 3 ? 'not-allowed' : 'pointer',
                            color: windowIndex >= sections.length - 3 ? 'var(--hairline-strong)' : "var(--accent)",
                            transition: 'color 0.2s'
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default TemplatesProgressBar;